/* eslint-disable prefer-destructuring,func-names,react/prop-types  */

import React, { Component } from 'react';
import _ from 'lodash';
import FileSaver from 'file-saver';
import Log from '../../../utils/Debug';

import KeyManagerCreateConfirmView from './KeyManagerCreateConfirmView';
import KeyManagerCreateProgressView from './KeyManagerCreateProgressView';
import KeyManagerCreateErrorView from './KeyManagerCreateErrorView';
import KeyManagerCreateSuccessView from './KeyManagerCreateSuccessView';

import {
  DISPLAY_CONFIRM,
  DISPLAY_PROGRESS,
  DISPLAY_SUCCESS,
  DISPLAY_ERROR,
} from '../../../store/keyManager/keyManagerConstants';

class KeyManagerCreateContainer extends Component {
  constructor(props) {
    super(props);
    this.onConfirm = this.onConfirm.bind(this);
    // this.onCreateToken = this.onCreateToken.bind(this);
    this.onDownloadToken = this.onDownloadToken.bind(this);
    this.onCopyToken = this.onCopyToken.bind(this);
  }

  onDownloadToken() {
    // Download to file system
    const { bearerToken } = this.props;
    const file = new Blob([bearerToken], { type: 'text/plain;charset=utf-8' }); // eslint-disable-line
    FileSaver.saveAs(file, 'BearerToken.txt');
  }

  onCopyToken() {
    const { bearerToken } = this.props;
    // Copy the token to the clipboard
    navigator.clipboard.writeText(bearerToken).then(() => { // eslint-disable-line
      /* clipboard successfully set */
      Log.info('clipboard successfully set');
    }, () => {
      Log.info('clipboard write failed');
    });
  }

  onConfirm() {
    // Start token creation
    this.onCreateToken();
  }

  onDone() {
  }

  render() {
    const {
      displayMode,
      lastError,
      // keys,
      // progress,
      bearerToken,
    } = this.props;

    let displayContent;

    switch (displayMode) {
      // case DISPLAY_CONFIRM:
      //   displayContent = (<KeyManagerCreateConfirmView
      //     displayText="Are you sure?"
      //     onHideModal={this.onDone}
      //     onCreateToken={this.onConfirm}
      //   />);
      //   break;
      case DISPLAY_PROGRESS:
        displayContent = (<KeyManagerCreateProgressView
          status="Creating Key..."
          onHideModal={this.onDone}
        />);
        break;
      case DISPLAY_SUCCESS:
        displayContent = (<KeyManagerCreateSuccessView
          bearerToken={bearerToken}
          displayToken={this.props.displayToken}
          onDownloadToken={this.onDownloadToken}
          onDisplayToken={this.props.onDisplayToken}
          onCopyToken={this.onCopyToken}
          onHideModal={this.onDone}
        />);
        break;
      case DISPLAY_ERROR:
        displayContent = (<KeyManagerCreateErrorView
          displayText={`${lastError.message} ${_.get(lastError, 'response.request.response')}`}
          onHideModal={this.onDone}
        />);
        break;
      default:
        displayContent = '<div />';
    }
    Log.info(this.props, 'Render KM Create with Props ::');

    return displayContent;
  }
}

export default KeyManagerCreateContainer;

